import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, map } from 'rxjs';
import { ManagementUser, EditableManagementUser } from '../models/management-user.model';

import { environment } from '../../../environments/environment';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private httpClient: HttpClient,
    private sessionStorageService: SessionStorageService,
  ) { }

  getSchoolUsers(): Observable<ManagementUser[]> {
    const reqOpts = {
      withCredentials: true,
    };

    const user = this.sessionStorageService.getUserData() ;
    if (!user || !user.schoolID) return of([]) ;

    return this.httpClient.get<ManagementUser[]>(`${environment.dataServicesURL}users/school/${user.schoolID}/list`, reqOpts) ;
  }

  saveSchoolUsers(users: EditableManagementUser[], notify: boolean): Observable<{ success: boolean, existingAccounts: string[] }> {
    const reqOpts = {
      withCredentials: true,
    };

    return this.httpClient.post(`${environment.dataServicesURL}users/add/management?notify=${notify}`, users, reqOpts).pipe(
      map((res: any) => {
        return {
          success: res.success,
          existingAccounts: res.existingAccounts,
        }
      })
    );
  }

  editSchoolUser(user: EditableManagementUser): Observable<any> {
    const reqOpts = {
      withCredentials: true,
    };

    return this.httpClient.put(`${environment.dataServicesURL}users/edit/management/${user.userID}`, user,  reqOpts) ;
  }

  archiveSchoolUsers(users: ManagementUser[]): Observable<any> {
    const reqOpts = {
      withCredentials: true,
    };

    return this.httpClient.put(`${environment.dataServicesURL}users/archive/management/`, users,  reqOpts) ;
  }
}
